import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ISlimScrollOptions } from 'ng2-slimscroll';

import {
  MessageEvent, SignInEvent, LoaderEvent, OpenFrameEvent, HiddenFooter,
} from './../../shared/message.event';

import { UtilityFunctions } from '../../shared/utility-functions';
import { AuthenticationService } from '../shared/authentication.service';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';

@Component({
  selector: 'app-vendor-profile',
  templateUrl: './vendor-profile.component.html',
  styleUrls: ['./vendor-profile.component.css'],
  providers: [MessageEvent, SignInEvent, LoaderEvent, OpenFrameEvent, HiddenFooter, AuthenticationService]
})
export class VendorProfileComponent implements OnInit {

  private vendor;
  private uiSetting;
  private height;
  private scrollOptions: ISlimScrollOptions;
  private utilityFunctions = new UtilityFunctions;
  private isReadOnly: boolean;
  filesToUpload: any = '';
  private fileUrl;
  private alertMessage = '';
  private errorMessage = '';
  private validate = {
    validateWebsite: '',
    termsAndConditions: '',
    cancellationAndRefund: '',
    privacy: ''
  }
  @ViewChild('fileUploadInput')
  fileUploadInputVariable: any;
  constructor(public router: Router, private authenticationService: AuthenticationService,
    private loaderEvent: LoaderEvent, private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent,
    private signInEvent: SignInEvent, private hiddenFooter: HiddenFooter, ) {
    this.uiSetting = {
      'windowHeight': window.innerHeight,
      'topNav': 56,
      'midNav': 45,
      'footer': 35,
      'container': 75
    };
    this.scrollOptions = {
      barBackground: "#343a40", barOpacity: "0.6", position: "right",
      barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", gridBackground: "#adb5bd", gridOpacity: "1",
      gridWidth: "4", gridBorderRadius: "10", gridMargin: "1px 2px"
    };

    this.height = 0;
    // calculating height of current frame
    this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav +
      this.uiSetting.container + this.uiSetting.footer)) + 'px';
  }
  private shouldSlide: boolean = false;
  ngOnInit() {
    if (localStorage.getItem('vendor')) {
      this.emitOpenFrameEvent();
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    }
    this.registerTypeBroadcast();
    this.emitTypeBroadcast();
    this.getVendorInfo();

  }
  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }
  /**
* while menu slide left to right as well as we shift header, footer and body too like menu by broadcaster  
*/

  registerTypeBroadcast() {
    this.messageEvent.on()
      .subscribe(message => {
        this.shouldSlide = message;
      });
  }

  /**
 * function show menu at facility page by broadcaster
 */

  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  /**
     * Redirecting to member page
     */

  homeScreen() {
    this.utilityFunctions.homeScreen(this);
  }


  /**
   * 
   * @memberof VendorProfileComponent
   */
  editVendor(): void {
    this.loaderEvent.fire(false);
    this.isReadOnly = true;
    let form_data = new FormData();
    form_data.append('systemUserId', (this.vendor._id));
    form_data.append('token', (this.vendor.token));
    form_data.append('file', this.fileUrl);
    form_data.append('description', this.vendor.description);
    form_data.append('website', this.vendor.website);
    form_data.append('termsAndConditions', this.vendor.termsAndConditions);
    form_data.append('cancellationAndRefund', this.vendor.cancellationAndRefund);
    form_data.append('privacy', this.vendor.privacy);
    form_data.append('Content-Type', 'application/x-www-form-urlencoded');
    form_data.append('vendorId', (this.vendor._id));
    let appVersion = localStorage.getItem('appVersion')
    if (appVersion) {
      form_data.append('appVersion', (appVersion).toString());
    }
    form_data.append('deviceType', (CONSTANT_VALUES.DEVICE_TYPE).toString());
    this.authenticationService.editVendorInfo(form_data).then((result: any) => {
      if (result.status == CONSTANT_VALUES.RESPONSE_SUCCESS) {
        this.getVendorInfo();
        this.loaderEvent.fire(true);
      } else {
        this.loaderEvent.fire(true);
      }
    });
  }

  getVendorInfo(): void {
    this.loaderEvent.fire(false);
    let vendorId = '';
    if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {

      if (this.vendor.subVendors.length > 0) {
        vendorId = this.vendor.subVendors[0]._id;
      }
    } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
      vendorId = this.vendor.vendorId;
    } else {
      vendorId = this.vendor._id;
    }

    let reqObj = {
      vendorId: vendorId
    }
    this.authenticationService.getVendorInfo(reqObj).then((result: any) => {
      if (result.status == CONSTANT_VALUES.RESPONSE_SUCCESS) {
        result.vendor[0].description = result.vendor[0].description ? result.vendor[0].description.replace(/(\r)/gm, '') : '';
        this.vendor.clubImageUrl = result.vendor[0].clubImageUrl;;
        this.vendor.description = result.vendor[0].description;
        this.vendor.website = result.vendor[0].website;
        this.vendor.termsAndConditions = result.vendor[0].termsAndConditions;
        this.vendor.cancellationAndRefund = result.vendor[0].cancellationAndRefund;
        this.vendor.privacy = result.vendor[0].privacy;
        this.setValues();

        this.loaderEvent.fire(true);
      } else {
        this.loaderEvent.fire(true);
      }
    });
  }

  changeStatusToEditVendor() {
    this.isReadOnly = false;
  }

  setValues() {
    this.isReadOnly = true;
    this.filesToUpload = this.vendor.clubImageUrl;
    this.vendor.description = !this.vendor.description || this.vendor.description == null ? '' : this.vendor.description;
    this.vendor.website = !this.vendor.website || this.vendor.website == null ? '' : this.vendor.website;
    this.vendor.termsAndConditions = !this.vendor.termsAndConditions || this.vendor.termsAndConditions == null ? '' : this.vendor.termsAndConditions;
    this.vendor.cancellationAndRefund = !this.vendor.cancellationAndRefund || this.vendor.cancellationAndRefund == null ? '' : this.vendor.cancellationAndRefund;
    this.vendor.privacy = !this.vendor.privacy || this.vendor.privacy == null ? '' : this.vendor.privacy;
  }

  removeImage() {
    this.filesToUpload = '';
    this.fileUploadInputVariable.nativeElement.value = '';
  }

  /**
   * 
   * 
   * @param {any} event 
   * @param {any} alertImagePopUpObj 
   * @memberof VendorProfileComponent
   */
  uploadFile(event, alertImagePopUpObj) {
    this.loaderEvent.fire(false);
    this.fileUrl = event.target.files[0];
    let input = event.target;
    let file = input.files[0];
    const that = this;
    let reader: FileReader = new FileReader();
    if (file) {
      if (file.name.indexOf('.jpg') > 0 || file.name.indexOf('.png') > 0 || file.name.indexOf('.bmp') > 0
        || file.name.indexOf('.jpeg') > 0 || file.name.indexOf('.tiff') > 0) {
        this.readFile(file, reader, (result) => {
          that.filesToUpload = result;
          that.loaderEvent.fire(true);
        });
      } else {
        that.loaderEvent.fire(true);
        that.alertMessage = CONSTANT_MESSAGES.IMAGE_ERROR;
        alertImagePopUpObj.showChildModal();
      }
    } else {
      this.loaderEvent.fire(true);
    }
  }

  /**
   * 
   * 
   * @param {any} file 
   * @param {any} reader 
   * @param {any} callback 
   * @memberof VendorProfileComponent
   */
  readFile(file: any, reader: FileReader, callback) {
    reader.onload = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  }

  checkUrl(url, field) {
    let regEx = /^http(s)?:\/\/(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
    if (url) {
      if (!regEx.test(url)) {
        this.validate[field] = 'required';
        return true;
      } else {
        this.validate[field] = '';
        return false;
      }
    } else {
      this.validate[field] = '';
    }
  }

  validateAll() {
    if (!this.checkUrl(this.vendor.website, 'website') && !this.checkUrl(this.vendor.privacy, 'privacy')
      && !this.checkUrl(this.vendor.cancellationAndRefund, 'cancellationAndRefund') && !this.checkUrl(this.vendor.termsAndConditions, 'termsAndConditions')) {
      this.editVendor();
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/vendor-profile/vendor-profile.component.ts